// TODO revert this to use import once webpack supports tree-shaking
// const { isURL, isEmail } = require('validator')
const validator = {
    isURL: require('validator/lib/isURL'),
    isEmail: require('validator/lib/isEmail'),
}
const log = require('log').create('validator') // eslint-disable-line

const has_schema_regex = /^https?:\/\//i

// validator package doesn't accept mailto: urls. if we need that in future,
// we'll need to add some conditionality to the above wrapper
// https://github.com/chriso/validator.js/issues/128

// simple wrapper for validator.isEmail
function isEmail(url) {
    return validator.isEmail(url)
}

function hasSchema(url) {
    return has_schema_regex.test(url)
}

function addSchema(input_url, schema = 'http') {
    let url = input_url

    if (! hasSchema(url)) {
        url = `${schema}://${url}`
    }

    return url
}

function removeSchema(input_url) {
    return input_url.replace(has_schema_regex, '')
}

// simple wrapper for validator.isURL
function isURL(url) {
    // don't allow @ in a domain
    const domain = removeSchema(url).split('/')[0]
    if (domain.match(/@/)) return false

    return validator.isURL(url)
}

function hasHash(u) {
    return u.split('#').length > 1
}

function hasPath(u) {
    return removeSchema(u).replace(/\/$/).split('/').length > 1
}

function hasQuery(u) {
    return u.split('?').length > 1
}

function hasPort(u) {
    return removeSchema(u).split(':').length > 1
}

// check for plain domain or subdomain
// no paths, hashes, queries, or ports
function isPlainDomain(url) {
    return (
        isURL(url)
        && ! hasSchema(url)
        && ! hasPath(url)
        && ! hasHash(url)
        && ! hasQuery(url)
        && ! hasPort(url)
    )
}

module.exports = {
    isEmail,
    hasSchema,
    addSchema,
    removeSchema,
    isURL,
    hasHash,
    hasPath,
    hasQuery,
    hasPort,
    isPlainDomain,
}
